// external imports
import { graphql } from 'react-relay'
// local imports
import mutationFromQuery from './mutationFromQuery'

export default mutationFromQuery(graphql`
    mutation sendContactEmailMutation($input: sendContactEmailInput!) {
        sendContactEmail(input: $input) {
            success
        }
    }
`)



// WEBPACK FOOTER //
// ./src/mutations/sendContactEmail.js